<template>
   <div class="d-flex flex-stack bg-white p-5 card shadow-sm ">
        <TaskActionBar :query="query" :showSearch="showSearch" :handleRangeDate="handleRangeDate"/>
    </div>
    <div class="stepper mt-10 mb-5 align-items-center justify-content-center">
        <StepperNav v-model="query.milestone" active-step="" :step-count="milestones">
          <template #default="{ step, index }">
            <span v-if="step?.total_task_need_review" class="me-3">|</span>
              <span v-if="step?.total_task_need_review" class="d-flex me-5">
              <span class="me-2" :style="{color: query.milestone === step?.id ? '#fff' : '#5e6278'}">{{ (step?.total_task_remaining_review || 0) + '/' + (step?.total_task_need_review || 0) }}</span>
              <img src="/assets/media/tasks/review_white.png" v-if="query.milestone === step?.id" style="height: 18px;" :title="$t('projects.label.total_task_remaining_review')"/>
              <img src="/assets/media/tasks/review.png" v-else style="height: 18px;" :title="$t('projects.label.total_task_remaining_review')"/>
            </span>
            <span v-if="step.alert_count" class="badge badge-danger ms-2 pulse-anim-infinite">
              {{ step.alert_count }}
            </span>
          </template>
        </StepperNav>
    </div>

    <KanbanView ref="kanbanComponent" :key="query.milestone" @change="reloadData" :filter="query" v-if="route.query.viewType === modelViewType.kanban" />
    <ListView ref="defaultComponent" :filter="query" v-else />

  </template>
  <script setup>
  import {onBeforeMount, onMounted, ref, watch} from "vue";
  import {useStore} from "vuex";
  import { useRoute, useRouter } from 'vue-router'
  import {useModelViewType} from "@/composables/modelViewType";
  import ListView from './List.vue'
  import KanbanView from './Kanban.vue'
  import TaskActionBar from "../../components/TaskActionBar.vue";
  import StepperNav from "@/components/Stepper/StepperNav.vue"; 
  import { computed } from "vue";
  
  const store = useStore()
  const route = useRoute()
  const router = useRouter()
  const { modelViewType } = useModelViewType()
  const showSearch = ref(false)
  
  const emits = defineEmits(['reloadData'])
  
  const query = ref({
    startDate: '',
    endDate: '',
    search: '',
    status: '',
    milestone: '',
    priority: '' 
  })
  const kanbanComponent = ref()
  const defaultComponent= ref()
  
  const milestones = computed(() => store.getters['projectSteps/getProjectSteps'])

  watch(() => milestones.value, (value) => {
    if (value.length > 0) {
      if (!route.query.step && query.value.milestone !== value[0]?.id) {
        query.value.milestone = value[0]?.id;
      }
      if (route.query.step && query.value.milestone !== route.query.step) {
        query.value.milestone = route.query.step;
      }
    }
  }, { deep: true });

  watch(() => query.value.milestone, (value) => {
    if(value && value !== route.query.step){
      router.replace({ query: { ...route.query, step: value } });
    }
  })

  function handleRangeDate (range) {
    query.value.startDate = range.start_date
    query.value.endDate = range.end_date
  }

  
  watch(() => route.query.viewType, (value) => {
    if (value === modelViewType.value.list) showSearch.value = false
    else showSearch.value = true
  })

  watch(() => query.value.milestone, () => {
    if(kanbanComponent.value) {
      kanbanComponent.value.destroyKanban()
      kanbanComponent.value.loadTaskByStatus()
    }
  }, { immediate: true })
  
  onBeforeMount(() => {
    if(!route.query.viewType) {
      route.query.viewType = modelViewType.value.kanban
    }
  })
  
  function loadData() {
    Promise.all([
      store.dispatch('projectSteps/loadProjectSteps', route.params.id),
      store.dispatch('taskPriorities/loadTaskPriorities'),
      store.dispatch('taskStatus/loadTaskStatus'),
      store.dispatch("user/loadUsers"),
    ])
  }

  function reloadData(){
    store.dispatch('projectSteps/loadProjectSteps', route.params.id)
    store.dispatch('projects/getTaskAlertCountByOffice', null)

    emits('change')
  }
  
  onMounted(() => {
    loadData()
    showSearch.value = route.query.viewType === modelViewType.value.list ? false : true
  })
  
  
  </script>